import React from 'react';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { EmptyStateCardBody } from '../../../components/EmptyStateCard';

const i18Path = 'approvalRequest.table';

export const EmptyApprovalRequestsCard: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);

  return <EmptyStateCardBody title={t('emptyStateMessage')} />;
};
